import React, { useEffect, useState } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useQuery, useQueries } from 'react-query'
import { getPhaseRSC, getLongEventRSC } from 'helpers/rsc'
import { getCumulativeResult, getResultsRSC, getStats } from "data/Querys"
import NotAvailable from 'components/common/NotAvailable'
import Loader from "components/general/Loader";
import Label from "components/general/Label"
import PlayOff from 'components/sports/glf/component/PlayOff'
import PageHeader from "components/common/PageHeader";

//Views
import GlfLeaderboard from 'components/sports/glf/views/GlfLeaderboard'
import GlfTeetimes from 'components/sports/glf/views/GlfTeetimes'
import GlfCoursestats from 'components/sports/glf/views/GlfCoursestats'
import GlfPlayerstats from 'components/sports/glf/views/GlfPlayerstats'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MyLeaderboard from "components/sports/glf/component/MyLeaderboard";


const GlfContext = () => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const _longevent = getLongEventRSC(mirs_rsc);
    const _phase = getPhaseRSC(mirs_rsc);
    let queryArray = [];
    let queryArrayStats = [];
    let queryArrayPlayerStats = [];
    let queryPlayoffs = [];

    const [favData, setFavData] = useState([]); // array with selected favourites players

    const _playoffs = [
        _phase + '0000RR--'
        , _phase + '0001RR--'
        , _phase + '0002RR--'
        , _phase + '0003RR--'
    ];

    const _units = [
        _phase + '000100--'
        , _phase + '000200--'
        , _phase + '000300--'
        , _phase + '000400--'
    ];

    //CUMULATIVE DATA
    const { data: cumulativeData, isError: cumulativeError, isLoading: cumulativeLoading } = useQuery(
        {
            queryKey: ['cumulativeData', mirs_competition, mirs_language, _longevent],
            queryFn: getCumulativeResult,
            refetchInterval: 10000,
            //staleTime: 10000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error']
        }
    )

    //UNITS DATA
    _units.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit, mirs_language, unit, null, null, _longevent],
            queryFn: getResultsRSC,
            refetchInterval: 10000,
            //staleTime: 10000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    //STATS BY EVENT 
    queryArrayStats.push({
        queryKey: ['stats', mirs_competition, mirs_language, _longevent, _phase + '000100--', 'TOU'],
        queryFn: getStats,
        refetchInterval: 10000,
        //staleTime: 10000,
        refetchIntervalInBackground: true,
        notifyOnChangeProps: ['data', 'error'],
    })

    //STATS BY UNIT
    _units.forEach((unit) => {
        queryArrayStats.push({
            queryKey: ['stats', mirs_competition, mirs_language, unit, unit, 'TOU'],
            queryFn: getStats,
            refetchInterval: 10000,
            //staleTime: 10000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    //CUM STATS BY PHASE
    queryArrayPlayerStats.push({
        queryKey: ['playerstats', mirs_competition, mirs_language, _longevent, _phase + '000100--', 'CUM'],
        queryFn: getStats,
        refetchInterval: 10000,
        //staleTime: 10000,
        refetchIntervalInBackground: true,
        notifyOnChangeProps: ['data', 'error'],
    })

    //CUM STATS BY UNIT
    _units.forEach((unit) => {
        queryArrayPlayerStats.push({
            queryKey: ['playerstats', mirs_competition, mirs_language, unit, unit, 'CUM'],
            queryFn: getStats,
            refetchInterval: 10000,
            //staleTime: 10000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    //PLAY OFFS
    _playoffs.forEach((unit) => {
        queryPlayoffs.push({
            queryKey: ['resultsData', mirs_competition, unit, mirs_language, unit, null, null, _longevent],
            queryFn: getResultsRSC,
            refetchInterval: 10000,
            //staleTime: 10000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    const unitsData = useQueries(queryArray);
    const statsData = useQueries(queryArrayStats);
    const playerStatsData = useQueries(queryArrayPlayerStats);
    const playOffData = useQueries(queryPlayoffs);

    const isLoading = cumulativeLoading
        || unitsData.some(result => result.isLoading)
        || statsData.some(result => result.isLoading)
        || playerStatsData.some(result => result.isLoading)
        || playOffData.some(result => result.isLoading)
    const isError = cumulativeError
        || unitsData.some(result => result.isError)
        || statsData.some(result => result.isError)
        || playerStatsData.some(result => result.isError)
        || playOffData.some(result => result.isError)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    return (
        <>
            <PageHeader title={unitsData[0]?.data?.results?.eventUnit?.phase?.description} />

            <div className='mirs-page-container'>
            {
                playOffData.map(po => {
                    return (
                        po?.data?.results
                            ? <PlayOff key={`po-${po.data?.results?.eventUnitCode}`} data={po.data} />
                            : ''
                    )
                })
            }
            {
                favData.length > 0 && <MyLeaderboard cumulativeData={cumulativeData} unitsData={unitsData} statsData={statsData} playerStatsData={playerStatsData} favData={favData} setFavData={setFavData}/>
            }            
            <Tabs id="mirs-navsport"
                defaultActiveKey={`1-${mirs_rsc}`}
                className="mb-3 mirs-tab-result"
                mountOnEnter={true}
                unmountOnExit={true}
            >
                <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="HeaderLeaderboard" />} disabled={false} >
                    <GlfLeaderboard 
                        cumulativeData={cumulativeData} 
                        unitsData={unitsData} 
                        statsData={statsData} 
                        playerStatsData={playerStatsData} 
                        favData={favData} 
                        setFavData={setFavData}
                        isMyLeaderboard={false}/>
                </Tab>
                <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderTeeTimes" />} disabled={false}>
                    <GlfTeetimes cumulativeData={cumulativeData} unitsData={unitsData} />
                </Tab>
                <Tab eventKey={`3-${mirs_rsc}`} title={<Label data="HeaderPlayerStats" />} disabled={false}>
                    <GlfPlayerstats />
                </Tab>
                <Tab eventKey={`4-${mirs_rsc}`} title={<Label data="HeaderCourseStats" />} disabled={false}>
                    <GlfCoursestats results={statsData} />
                </Tab>
            </Tabs>
            </div>
        </>
    );
};

export default GlfContext;
